<div class="ols-form">
  <div class="ols-form-wrapper">
    <div class="ols-form-group"
      [ngClass]='{ "has-focus": numberFocus, "has-success": validNumber(), "has-error": !validNumber() && numberHadFocus, "is-empty": isNumberLeeg() }'>
      <div class="ols-label">
        <div class="ols-label-leading"></div>
        <label for="number">{{labelNumber}}</label>
      </div>
      <input #numberField [disabled]="!isCurrentVraag" [required]="numberRequired" type="number" step="1" name="number"
        [(ngModel)]="getal" (focus)='setNumberFocus(true)' (blur)='setNumberFocus(false)'
        (keypress)='isNumberKey($event)'>
      <p class="error-block" *ngIf="!validNumber() && !isNumberLeeg() && numberHadFocus">{{errormessageNumber}}</p>
      <p class="error-block" *ngIf="isNumberLeeg() && numberHadFocus">Vul alsjeblieft het aantal in</p>
    </div>
  </div>
</div>